import { render, staticRenderFns } from "./pop-up.vue?vue&type=template&id=97712ca6&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"
import style0 from "./pop-up.vue?vue&type=style&index=0&id=97712ca6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97712ca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97712ca6')) {
      api.createRecord('97712ca6', component.options)
    } else {
      api.reload('97712ca6', component.options)
    }
    module.hot.accept("./pop-up.vue?vue&type=template&id=97712ca6&scoped=true", function () {
      api.rerender('97712ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/matter-logs/pop-up.vue"
export default component.exports